import { render, staticRenderFns } from "./SelectedCandidates.vue?vue&type=template&id=3373c0d1&"
import script from "./SelectedCandidates.vue?vue&type=script&lang=js&"
export * from "./SelectedCandidates.vue?vue&type=script&lang=js&"
import style0 from "./SelectedCandidates.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports